module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pxiv"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "fronttitle "
  }, [_vm._v("Abbreviations of Book Titles")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("GRB")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("The Great Railway Bazaar")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("OPE")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("The Old Patagonian Express")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("KBS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("The Kingdom by the Sea")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("SWS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Sunrise with Seamonsters")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("RIR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Riding the Iron Rooster")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("TEE")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("To the Ends of the Earth")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("HIO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("The Happy Isles of Oceania")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("POH")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("The Pillars of Hercules")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("FAF")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Fresh Air Fiend")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("DSS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Dark Star Safari")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("GTES")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Ghost Train to the Eastern Star")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("WE")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("World’s End")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-135a5c6b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front04.vue
// module id = 69
// module chunks = 0